import React from 'react'
import { Checkbox, Form } from 'semantic-ui-react'

export default function LoginMethodCheckboxGroup({
  label = '',
  loginMethods = [],
  onChangeLoginMethods,
}) {
  const options = [
    { label: 'Email and password', value: 'email_password' },
    { label: 'Google and Microsoft', value: 'social_login' },
  ]

  return (
    <Form.Group grouped>
      {label && <label>{label}</label>}
      {options.map(({ label, value }) => (
        <Form.Field key={value}>
          <Checkbox
            label={label}
            value={value}
            checked={loginMethods.includes(value)}
            onChange={onChangeLoginMethods}
          />
        </Form.Field>
      ))}
    </Form.Group>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/LoginMethodCheckboxGroup/index.js